<template>
    <div class="listing-preview">
        <div class="modal-content-generic">
            <div class="content lh-loose">
                <section class="property-detail no-padding-bottom">
                    <div class="inner container">
                        <div
                            id="property-images"
                            class="image-gallery"
                            :class="{ expanded: imagesExpanded }"
                            v-if="Object.keys(listing.gallery).length"
                        >
                            <div class="inner">
                                <ul
                                    class="featherlight-gallery-container"
                                    v-featherlight-gallery
                                >
                                    <li v-for="media in listing.gallery">
                                        <div class="inner">
                                            <!-- <a :href="media.original_url"
                         class="interactive tinted tinted-hover tinted-20 tinted-hover-only">
                        <img :src="media.original_url" :alt="media.name" class="cover"/>
                      </a> -->
                                            <a
                                                :href="media.preview_url"
                                                class="interactive tinted tinted-hover tinted-20 tinted-hover-only"
                                            >
                                                <img
                                                    :src="media.preview_url"
                                                    :alt="media.name"
                                                    class="cover"
                                                />
                                            </a>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                            <div
                                class="show-all"
                                v-if="Object.keys(listing.gallery).length > 4"
                            >
                                <button
                                    type="button"
                                    class="button outline-black no-bdr sm"
                                    @click="imagesExpanded = !imagesExpanded"
                                    v-text="
                                        imagesExpanded
                                            ? 'Hide extended photos'
                                            : 'Show all photos'
                                    "
                                ></button>
                            </div>
                        </div>

                        <div class="details" id="property-details">
                            <div class="pane main">
                                <h2
                                    class="keyline wt-sb font-lg lh-tight"
                                    v-if="listing.space_name"
                                >
                                    {{ listing.space_name }}
                                </h2>

                                <div class="overview">
                                    <div class="location">
                                        <h3
                                            class="font-mdish wt-md lh-std"
                                            v-if="listing.name"
                                        >
                                            {{ listing.name }}
                                        </h3>

                                        <h4
                                            class="fg-brand-blue font-mdish wt-md lh-std"
                                            v-if="addressLabel"
                                        >
                                            {{ addressLabel }}
                                        </h4>

                                        <h4
                                            class="wt-md fg-light-grey lh-std"
                                            v-if="listing.property_type"
                                        >
                                            {{
                                                metaLabel(
                                                    "property_types",
                                                    listing.property_type
                                                )
                                            }}
                                        </h4>
                                    </div>
                                </div>
                                <!-- /.overview -->

                                <div
                                    id="property-description"
                                    class="content detail-section lined"
                                    v-if="
                                        listing.availability_types.length ||
                                        listing.description
                                    "
                                >
                                    <div
                                        class="property-tags"
                                        v-if="listing.availability_types.length"
                                    >
                                        <ul class="listing tags">
                                            <li
                                                v-for="id in listing.availability_types"
                                            >
                                                {{
                                                    metaLabel(
                                                        "availability_types",
                                                        id
                                                    )
                                                }}
                                            </li>
                                        </ul>
                                    </div>
                                    <!-- /.property-tags -->

                                    <template v-if="listing.description">
                                        <h4 class="fg-primary font-mdish wt-md">
                                            The space
                                        </h4>
                                        <div
                                            class="formatted property-description"
                                        >
                                            {{ listing.description }}
                                        </div>
                                    </template>
                                </div>
                                <!-- /.content -->

                                <div
                                    id="property-features"
                                    class="features detail-section lined"
                                    v-if="hasDetails"
                                >
                                    <h4 class="fg-primary font-mdish wt-md">
                                        All the important details
                                    </h4>
                                    <div
                                        class="feature-groups columned-listing two-columns"
                                    >
                                        <div
                                            class="group"
                                            v-if="listing.space_types.length"
                                        >
                                            <h5>Indoor & outdoor spaces</h5>
                                            <ul class="listing feature-listing">
                                                <li
                                                    v-for="id in listing.space_types"
                                                >
                                                    {{
                                                        metaLabel(
                                                            "space_types",
                                                            id,
                                                            "items"
                                                        )
                                                    }}
                                                </li>
                                            </ul>
                                        </div>

                                        <div
                                            class="group"
                                            v-if="
                                                listing.exterior_styles.length
                                            "
                                        >
                                            <h5>Architectural style</h5>
                                            <ul class="listing feature-listing">
                                                <li
                                                    v-for="id in listing.exterior_styles"
                                                >
                                                    {{
                                                        metaLabel(
                                                            "exterior_styles",
                                                            id,
                                                            "styles"
                                                        )
                                                    }}
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <!-- /.feature-groups -->
                                </div>
                                <!-- /.features -->

                                <div
                                    id="property-amenities"
                                    class="amenities detail-section lined"
                                    v-if="
                                        listing.logistics.length ||
                                        listing.land_size ||
                                        listing.building_size
                                    "
                                >
                                    <h4 class="fg-primary font-mdish wt-md">
                                        Property logistics
                                    </h4>
                                    <div class="amenities">
                                        <ul
                                            class="listing amenity-listing columned-listing two-columns"
                                        >
                                            <li v-if="listing.land_size">
                                                Land size: {{listing.land_size}}
                                            </li>
                                            <li v-if="listing.building_size">
                                                Building size: {{listing.building_size}}
                                            </li>
                                            <template
                                                v-if="listing.logistics.length"
                                            >
                                                <li
                                                    v-for="id in listing.logistics"
                                                >
                                                    {{
                                                        metaLabel(
                                                            "logistics",
                                                            id,
                                                            "items"
                                                        )
                                                    }}
                                                </li>
                                            </template>
                                        </ul>
                                    </div>
                                </div>
                                <!-- /.key-features -->

                                <div
                                    class="special-conditions detail-section lined"
                                    v-if="listing.terms_and_conditions"
                                >
                                    <h4 class="fg-primary font-mdish wt-md">
                                        Special conditions
                                    </h4>
                                    <div
                                        class="special-conditions-content formatted"
                                    >
                                        {{ listing.terms_and_conditions }}
                                    </div>
                                </div>
                            </div>
                            <!-- /.pane.main -->
                        </div>
                        <!-- /.details -->
                    </div>
                    <!-- /.inner -->
                </section>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        listing: {
            type: Object,
            required: true,
        },
        meta: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            imagesExpanded: false,
        };
    },
    methods: {
        metaLabel(prop, id, childProp) {
            if (typeof this.meta[prop] === "undefined") {
                return null;
            }
            if (childProp) {
                let l = null;
                for (let p of this.meta[prop]) {
                    let c = p[childProp].find((o) => o.id === id);
                    if (c !== "undefined" && c && c.label !== "undefined") {
                        l = c.label;
                        break;
                    }
                }
                return l;
            }
            return this.meta[prop].find((o) => o.id === id).label;
        },
    },
    computed: {
        addressLabel() {
            if (!this.listing.state && !this.listing.suburb) {
                return null;
            }
            if (!this.listing.state) {
                return this.listing.suburb;
            }
            return `${this.listing.suburb}, ${this.listing.state}`;
        },
        hasDetails() {
            return (
                this.listing.space_types.length ||
                this.listing.exterior_styles.length ||
                this.listing.logistics.length
            );
        },
    },
};
</script>
